import React from "react";
import {IconButton} from '@material-ui/core'
import {  
  ExpandMore as ExpandMoreIcon,
  ExpandLess as  ExpandLessIcon
} from "@material-ui/icons";
import {withStyles} from "@material-ui/core";
import Moment from 'moment';
import {inject} from 'mobx-react';

const CalendarioMinimizadoThreeDays = (props) =>{
  const { classes, dataAnterior, dataPosterior, onClickCurrentDayButton, atendimentoStore } = props;

  const tresDias = () =>{
    const start = Moment(atendimentoStore.selectedDate);
    const end = Moment(atendimentoStore.selectedDate).add(2, 'days');

    return `${start.format("DD")} à ${end.format("DD")}`  
  };

  return(
    <div className={classes.divDataAtualMinimizado}>
      <div id="agd-ctd-div-ant" onClick={dataAnterior}>
        <ExpandLessIcon className={classes.botoesMudarDia}/>
      </div>
      <div className={classes.dataAtual}> {tresDias()} </div>
      <div id="agd-ctd-div-pos" onClick={
        dataPosterior}>
        <ExpandMoreIcon className={classes.botoesMudarDia}/>
      </div>
      <IconButton
          id="agd-ctd-btn-hoj"
          onClick={onClickCurrentDayButton}
          className={classes.botaoDataAtual}
      >
          Hoje
      </IconButton>
  </div>
  )
}

const styles = theme => ({
  divDataAtualMinimizado:{
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    marginBottom: 15,
  },
  botoesMudarDia:{
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0.54)', 
    marginRight: '-5px'
  },
  dataAtual:{
    color: '#009A97',
    cursor: 'pointer',
    padding: '0px 0px 3px 0px',
    fontSize: 16,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  botaoDataAtual:{
    borderRadius: 0,
    padding: 7,
    fontSize: 14,
    color: '#27B0AD',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    cursor: 'pointer',
    marginTop: 10,
  },
  
})

const CalendarioMinimizadoThreeDaysWithStyles = withStyles(styles)(CalendarioMinimizadoThreeDays);
export default inject("atendimentoStore")(CalendarioMinimizadoThreeDaysWithStyles);